import { render, staticRenderFns } from "./TheBanner.vue?vue&type=template&id=0d3ff4b0&"
import script from "./TheBanner.vue?vue&type=script&lang=js&"
export * from "./TheBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports